import { makeAutoObservable } from 'mobx'
import * as R from 'ramda'

import SkipLogicAPI from '../API/SkipLogic'
import SkipLogicAction from './SkipLogicAction'
import TriggerGroup from './TriggerGroup'

class SkipLogic {
    triggerGroups

    constructor(skipLogic) {
        makeAutoObservable(this)
        Object.assign(this, skipLogic)
        this.action = new SkipLogicAction(skipLogic.action)
        this.triggerGroups = R.pathOr([], ['triggerGroups'], skipLogic).map((tg) => new TriggerGroup(tg, null, null, skipLogic))

        if (this.trigger && !['QuestionOptionExistsInSurveyResponse', 'Quota'].includes(this.trigger.condition.kind)) {
            this.action.kind = 'PageToPage'
        }

        // if (this.action.kind === 'PageToPage') {
        //     Reflect.deleteProperty(this, 'triggerGroups')
        // } else {
        //     Reflect.deleteProperty(this, 'trigger')
        // }

    }

    getPageQuestionId = () => {
        const { action } = this
        const { kind } = action

        switch (kind) {
            case 'SkipToPage':
                return R.pathOr(null, ['triggerGroups', 0, 'children', 0, 'triggers', 0, 'condition', 'pageQuestionId'], this)
            case 'ShowQuestion':
                return R.pathOr(null, ['action', 'pageQuestionId'], this)
            default:
                return null
        }
    }

    triggerChildRemoved() {
        this.removeTriggerGroup(this.triggerGroups.findIndex(triggerGroup => triggerGroup.children.length === 0))
    }

    changeTriggerOperator(index, childIndex, operator) {
        const tmp = this.triggerGroups[index]
        console.log(tmp)
        tmp.updateTriggerOperator(childIndex, operator)
        console.log(JSON.stringify(tmp))
    }

    updateTriggerGroupOperator(index, childIndex, operator) {
        this.triggerGroups[index].updateTriggerGroupOperator(childIndex, operator)
    }

    updateGroupOperator(index, operator) {
        this.triggerGroups[index].updateGroupOperator(operator)
    }

    removeTriggerGroup(index) {
        console.log(`removeTriggerGroup ${index}`)
        if (index === -1) return
        console.log(`removeTriggerGroup ${index} ${this.pendingRemove}`)
        if (index > 0 || this.triggerGroups.length > 1) {
            this.triggerGroups.splice(index, 1)
        } else if (index === 0 && this.triggerGroups.length === 1) {
            this.triggerGroups[0].children = []
        }

        // if (this.pendingRemove) {
        //     console.log(`this.triggerGroups[0].isEmpty ${this.triggerGroups[0].isEmpty}`)
        //     if (this.triggerGroups.length > 1 || !this.triggerGroups[0].isEmpty) {
        //         this.save()
        //     } else if (this.triggerGroups[0].isEmpty) {
        //         this.remove()
        //     }
        // }
    }

    addGroup() {
        console.log('SkipLogic addGroup')
        this.triggerGroups.push(new TriggerGroup({
            children: [],
            interGroupLogicalOperator: 'OR',
        }, this.store, null, this))
    }

    toJSON() {
        const json = {
            id: this.id,
            skipLogicGroupId: this.skipLogicGroupId,
            action: this.action.toJSON(),
            triggerGroups: (!['PageToPage', 'OverallQuotaTopage'].includes(this.action.kind) ? this.triggerGroups.map(triggerGroup => triggerGroup.toJSON()) : null),
            trigger: (this.action.kind === 'PageToPage' || this.trigger ? this.trigger : null),
        }

        if (json.action.kind === 'SkipToPage') {
            console.log(JSON.stringify(json, null, 4))
        }

        /**
         * remove ones scala has PageToPage support
         */
        if (this.action.kind === 'PageToPage') {
            json.action.kind = 'SkipToPage'
        }

        Object.keys(json).forEach((key) => {
            if (json[key] === null) {
                delete json[key]
            }
        })

        return json
    }

    save(store) {
        console.log('Saving SkipLogic')
        console.log(JSON.stringify(this, null, 4))
        this.id ? SkipLogicAPI.update(this, store) : SkipLogicAPI.save(this, store)
    }

    remove(store) {
        console.log('SkipLogic remove')
        SkipLogicAPI.remove(this, store)
    }

    isEmpty() {
        let empty = false
        if (this.action.kind === 'ShowQuestion' || this.action.kind === 'HideQuestion') {
            const childCount = this.triggerGroups.reduce((count, triggerGroup) => {
                return count + triggerGroup.children.length
            }, 0)
            empty = empty || this.triggerGroups.length === 0 || childCount === 0
        }

        return empty
    }

    refersToQuestion = (rule, questionId) => (
        (
            rule.action.pageQuestionId
            && rule.action.pageQuestionId.toUpperCase() === questionId.toUpperCase()
        )
        || (
            rule.triggerGroups.some((triggerGroup) => (
                triggerGroup.children
                    ? triggerGroup.children.some((child) => (
                        child.triggers
                            ? child.triggers.some((trigger) => (
                                R.pathOr('', ['condition', 'pageQuestionId'], trigger).toUpperCase() === questionId.toUpperCase()
                            ))
                            : false
                    ))
                    : false
            ))
        )
    )

    pageQuestionRemoved(pageQuestionId) {
        console.log(`pageQuestionRemoved ${this.id} => ${pageQuestionId}`)
        const { kind } = this.action
        if (kind === 'ShowQuestion' || kind === 'HideQuestion') {
            const triggerChildren = this.triggerGroups.reduce((children, triggerGroup) => {
                return children.concat(triggerGroup.children)
            }, [])

            const childrenToRemove = triggerChildren.filter(child => {
                console.log(`child ${child.id} ${child.getPageQuestionId()} ${pageQuestionId}`)
                return child.getPageQuestionId() === pageQuestionId
            })
            console.log(childrenToRemove)
            childrenToRemove.forEach(child => child.clear())
            this.pendingRemove = false
            if (this.isEmpty(pageQuestionId)) {
                this.remove()
            } else if (childrenToRemove.length > 0) {
                this.save()
            }
        } else if (kind === 'SkipToPage') {
            if (this.triggerGroups[0].children[0].triggers[0].condition.pageQuestionId === pageQuestionId) {
                this.remove()
            }
        }
    }

    pageRemoved(page, store) {
        if (this.action.kind === 'ShowQuestion' || this.action.kind === 'HideQuestion') {
            page.questions.forEach(pageQuestion => this.pageQuestionRemoved(pageQuestion.id))
        } else if (this.action.kind === 'SkipToPage') {
            if (this.action.pageId === page.id) {
                this.remove(store)
            }
        } else if (this.trigger.condition.pageId === page.id) {
            this.remove(store)
        }
    }
}

export default SkipLogic
